import * as React from 'react';
import styles from './Acknowledgement.module.scss';
import Clipboard from '../../common/Clipboard';
import successImg from './img/success-primary.svg';

export type AcknowledgementProps = {
    /**
     *
     */
    orderId: string;
    shopping: string;
    isOrbis: boolean;
};

export const Acknowledgement: React.FC<AcknowledgementProps> = ({
    orderId,
    shopping,
    isOrbis,
}: AcknowledgementProps) => (
    <div className={styles['acknowledgement']}>
        <img className={styles['success-img']} alt="Éxito" src={successImg} />
        <h3 className={styles['title']}>
            {shopping == 'Kiosko'
                ? '¡Reserva exitosa!'
                : isOrbis
                ? 'Tu reserva ha sido realizada'
                : '¡Gracias por tu compra!'}
        </h3>
        <p className={styles['text']}>
            Tu número de orden es{' '}
            <Clipboard>
                <b>{orderId}</b>
            </Clipboard>
        </p>
        <hr className={styles['separator']} />
    </div>
);
